import React, { useState } from 'react'
import { Skeleton } from '../../../components/Skeleton/Skeleton'

const VIEWS = [
  { value: 'byPerson', label: 'By person' },
  { value: 'byOffice', label: 'By office' },
]

const Shell = ({ total, children, toggle }) => (
  <div className="border border-divider rounded-2xl p-5 bg-surface shadow-subtle dark:shadow-none">
    <div className="flex flex-wrap items-center justify-between gap-3">
      <div>
        <h3 className="text-md font-semibold text-text-primary">Who ran the pulls</h3>
        {total !== null && <p className="text-sm text-text-secondary">{total === 1 ? '1 pull' : `${total} pulls`}</p>}
      </div>
      {toggle}
    </div>
    <div className="mt-4">{children}</div>
  </div>
)

const CreditPullLeaderboard = ({ data, loading = false, error = false, onRetry }) => {
  const [view, setView] = useState('byPerson')

  if (loading) {
    return (
      <Shell total={null}>
        <div className="flex flex-col gap-3" data-testid="leaderboard-loading">
          <Skeleton width="100%" height={20} />
          <Skeleton width="100%" height={20} />
          <Skeleton width="100%" height={20} />
        </div>
      </Shell>
    )
  }

  if (error) {
    return (
      <Shell total={null}>
        <div className="flex items-center gap-3">
          <span className="text-sm text-text-secondary">Couldn't load the ranking</span>
          <button
            type="button"
            onClick={onRetry}
            className="text-sm font-medium text-text-primary underline"
          >
            Retry
          </button>
        </div>
      </Shell>
    )
  }

  const total = Number(data?.total) || 0
  const entries = Array.isArray(data?.[view]) ? data[view] : []
  const top = entries.reduce((max, entry) => Math.max(max, Number(entry.count) || 0), 0)

  const toggle = (
    <div className="inline-flex rounded-lg border border-divider overflow-hidden">
      {VIEWS.map((option) => (
        <button
          key={option.value}
          type="button"
          aria-pressed={view === option.value}
          onClick={() => setView(option.value)}
          className={`px-3 py-1 text-sm ${view === option.value ? 'bg-primary-main text-white' : 'text-text-secondary'}`}
        >
          {option.label}
        </button>
      ))}
    </div>
  )

  return (
    <Shell total={total} toggle={toggle}>
      {entries.length === 0 ? (
        <p className="text-sm text-text-secondary">No pulls in this period</p>
      ) : (
        <ul className="flex flex-col gap-3">
          {entries.map((entry) => {
            const count = Number(entry.count) || 0
            const percent = top > 0 ? Math.round((count / top) * 100) : 0
            return (
              <li key={entry.key} data-testid="leaderboard-row">
                <div className="flex items-center justify-between gap-3 text-sm">
                  <span className="text-text-primary truncate">{entry.label}</span>
                  <span className="text-text-secondary tabular-nums">{count}</span>
                </div>
                <div className="mt-1 h-1.5 w-full rounded-full bg-divider">
                  <div
                    data-testid="leaderboard-bar"
                    className="h-1.5 rounded-full bg-primary-main"
                    style={{ width: `${percent}%` }}
                  />
                </div>
              </li>
            )
          })}
        </ul>
      )}
    </Shell>
  )
}

export default CreditPullLeaderboard
